import axios from "axios";
import { config } from "../../Network_Calls/config";

export const getOnData=async (impl_id,selectedDate) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_SERVER_URL + "/customer/current/events",{
          impl_id,
          selectedDate
        },
        {
          ...config(),
        }
      );
      return response;
    } catch (error) {
      console.log(error);
    }
  };


  export const getDates=async (impl_id) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_SERVER_URL + "/customer/current/events/dates",{
          impl_id
        },
        {
          ...config(),
        }
      );
      return response;
    } catch (error) {
      console.log(error);
    }
  };